// 枚举定义
export var PRODUCT_STATUS;
(function (PRODUCT_STATUS) {
    PRODUCT_STATUS[PRODUCT_STATUS["AVAILABLE"] = 1] = "AVAILABLE";
    PRODUCT_STATUS[PRODUCT_STATUS["UNAVAILABLE"] = 2] = "UNAVAILABLE";
})(PRODUCT_STATUS || (PRODUCT_STATUS = {}));
export var PRICE_TYPE;
(function (PRICE_TYPE) {
    PRICE_TYPE[PRICE_TYPE["DEFAULT"] = 0] = "DEFAULT";
    PRICE_TYPE[PRICE_TYPE["NO_PRICE"] = -1] = "NO_PRICE";
    PRICE_TYPE[PRICE_TYPE["NORMAL"] = 1] = "NORMAL";
})(PRICE_TYPE || (PRICE_TYPE = {}));
export var SUPER_SPU_TYPE;
(function (SUPER_SPU_TYPE) {
    SUPER_SPU_TYPE[SUPER_SPU_TYPE["SINGLE_POI"] = 1] = "SINGLE_POI";
    SUPER_SPU_TYPE[SUPER_SPU_TYPE["MULTI_POI"] = 2] = "MULTI_POI";
})(SUPER_SPU_TYPE || (SUPER_SPU_TYPE = {}));
// 枚举定义
export var SOURCE;
(function (SOURCE) {
    SOURCE[SOURCE["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    SOURCE[SOURCE["DIANPING_APP"] = 2] = "DIANPING_APP";
    SOURCE[SOURCE["MEITUAN_MINIAPP"] = 3] = "MEITUAN_MINIAPP";
    SOURCE[SOURCE["HOTEL_MINIAPP"] = 4] = "HOTEL_MINIAPP";
    SOURCE[SOURCE["DIANPING_MINIAPP"] = 5] = "DIANPING_MINIAPP";
})(SOURCE || (SOURCE = {}));
export var PLATFORM;
(function (PLATFORM) {
    PLATFORM[PLATFORM["MEITUAN"] = 1] = "MEITUAN";
    PLATFORM[PLATFORM["DIANPING"] = 2] = "DIANPING";
})(PLATFORM || (PLATFORM = {}));
// 客户端类型枚举
export var BASE_CLIENT_TYPE;
(function (BASE_CLIENT_TYPE) {
    BASE_CLIENT_TYPE[BASE_CLIENT_TYPE["IPHONE"] = 1] = "IPHONE";
    BASE_CLIENT_TYPE[BASE_CLIENT_TYPE["ANDROID"] = 2] = "ANDROID";
    BASE_CLIENT_TYPE[BASE_CLIENT_TYPE["WX"] = 3] = "WX";
    BASE_CLIENT_TYPE[BASE_CLIENT_TYPE["HARMONY"] = 4] = "HARMONY";
})(BASE_CLIENT_TYPE || (BASE_CLIENT_TYPE = {}));
